import CloudUser from './CloudUser'
import ClientAgent from '../clientAgent'

export class CloudUserList {
  /**
   *
   * @type {CloudUser[]}
   * @private
   */
  _list = []

  _ca = null

  async loadAllUsers () {
    let response = await this.ca.makeRequest('openStack/servisne/getAllCloudUsers', {})
    response.users.forEach((item) => {
      let user = CloudUser.getInstance(item.id)
      user.loadBasicUserData(item.id, item.ownUser, item.username, item.siteId, item.ownerEmail, item.email, item.gsm)
      this._list.push(user)
    })
  }

  /**
   * @param {CloudUser} user
   */
  addUserToList (user) {
    this._list.push(user)
  }

  /**
   * @param {CloudUser} user
   */
  removeUserFromList (user) {
    let found = false
    for (let i = 0; i < this._list.length; i++) {
      if (this._list[i].id === user.id) {
        found = true
        this._list.splice(i, 1)
        break
      }
    }
    if (!found) {
      throw new Error('Ne najdem uporabnika')
    }
  }

  /**
   * @param {number} id
   * @returns {null | CloudUser}
   */
  getUserById (id) {
    let user = null
    this._list.forEach((userLoop) => {
      if (userLoop.id === id) {
        user = userLoop
      }
    })
    return user
  }

  /**
   * @param {string} username
   * @returns {null | CloudUser}
   */
  getUserByUsername (username) {
    let user = null
    this._list.forEach((userLoop) => {
      if (userLoop.username === username) {
        user = userLoop
      }
    })
    return user
  }

  get list () {
    return this._list
  }

  set list (value) {
    this._list = value
  }

  get ca () {
    if (this._ca === null) {
      this._ca = new ClientAgent()
    }
    return this._ca
  }

  set ca (value) {
    this._ca = value
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/T2Cloud/CloudUserList.js